import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { tabImg, tabLink } from '../data/health'

export default function HealthTab() {
    let [activeTab, setActiveTab] = useState(1)
  return (
    <>
    <div className="row">
        <div className="col-lg-4 col-md-6 mt-4 pt-2">
            <ul className="nav nav-pills bg-transparent flex-column mb-0 sticky-bar">
                {tabLink.map((item,index)=>{
                    let Icon = item.icon
                    return(
                        <li className="nav-item mt-3" key={index}>
                            <Link href="#" className={`nav-link rounded border-0 d-flex rounded shadow p-3 bg-light align-items-center ${activeTab === item.id ? 'active' : ''}`} onClick={()=>setActiveTab(item.id)}>
                                <span className="icons h2 mb-0">
                                    <Icon className=""/>
                                </span>

                                <span className="flex-1 content ms-3">
                                    <span className="h5 mb-0 d-block">{item.name}</span>
                                    <small className="sub-title">{item.title}</small>
                                </span>
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </div>

        <div className="col-lg-8 col-md-6 col-12 mt-4 pt-2">
            <div className="tab-content">
                {tabImg.map((item,index)=>{
                    return(
                        <div className={`tab-pane fade ${activeTab === item.id ? 'show active' : ''}`} key={index}>
                            <img src={item.image} className="img-fluid rounded-4 shadow" alt=""/>
                        </div>
                    )
                })}
            </div>
        </div>
    </div> 
    </>
  )
}
